import { Box, Grid, Typography } from "@mui/material";
import downArrow from "assets/icons/down_arrow.png";
import { useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";
import { HOME_BODY_COLOR } from "styles/oneOffColor";

import StyledLargeButton from "components/Styled/Button/StyledLargeButton";
import { useTracking } from "utils/useTracking";

interface Props {
  finishSetUpLater: () => void;
}

const Welcome = ({ finishSetUpLater }: Props) => {
  const navigate = useNavigate();
  const { trackVaStep } = useTracking();

  return (
    <>
      <Grid
        item
        alignItems={"center"}
        container
        sx={{ backgroundColor: HOME_BODY_COLOR, borderRadius: 4, p: 3 }}
      >
        <Grid item xs={12} md={6} sx={{ p: 3 }}>
          <Typography>Welcome to</Typography>
          <Typography variant="h2" sx={{ mb: 2, fontSize: { xs: 20, md: 40 } }}>
            AI Virtual Assistant 🎉
          </Typography>

          <Typography gutterBottom sx={{ fontSize: 18, mb: 2 }}>
            <strong>You're just one step away from activating your VA.</strong>
          </Typography>

          <Typography sx={{ fontSize: 18 }}>
            Setup takes 5-10 minutes. You can pause and come back anytime from
            your dashboard.
          </Typography>
        </Grid>

        <Grid item xs md sx={{ p: 3 }}>
          <Box sx={{ backgroundColor: "white", p: 3, borderRadius: 4 }}>
            <Typography
              textAlign={"center"}
              gutterBottom
              variant="h6"
              sx={{ color: "purple.dark", textTransform: "uppercase" }}
            >
              We pitch
            </Typography>
            <Typography textAlign={"center"}>
              Bento's AI sends 300+ emails on your behalf each month, without
              you lifting a finger
            </Typography>

            <Box
              component="img"
              src={downArrow}
              sx={{ width: 15, my: 3, display: "block", mx: "auto" }}
            />

            <Typography
              textAlign={"center"}
              gutterBottom
              variant="h6"
              sx={{ color: "purple.dark", textTransform: "uppercase" }}
            >
              You respond
            </Typography>
            <Typography textAlign={"center"}>
              You respond and negotiate with brands when you get a response
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid
        container
        justifyContent="center"
        sx={{ mt: { xs: 2, md: 6 }, gap: 2 }}
      >
        <StyledLargeButton
          color="secondary"
          disableElevation
          styles={{ px: 3, fontSize: 16 }}
          onClick={finishSetUpLater}
        >
          I'll do it later
        </StyledLargeButton>
        <StyledLargeButton
          disableElevation
          styles={{ px: 3, fontSize: 16 }}
          onClick={() => {
            navigate(`/${routes.aboutSelfServeOnboarding}`);
            trackVaStep(routes.aboutSelfServeOnboarding);
          }}
        >
          Let's Get Started{" "}
        </StyledLargeButton>
      </Grid>
    </>
  );
};

export default Welcome;
